// extracted by mini-css-extract-plugin
module.exports = {"container":"styles-module--container--2_aOt","icon":"styles-module--icon--2f6yI","label":"styles-module--label--3W9pi"};